import _extends from "@babel/runtime/helpers/extends";
import React from 'react';
import { Field } from '../Field';
import { getId } from '../Field/Field';
import { textInputWidth } from '../Field/Field.styled';
import { useTranslate } from '../util';
import { TextInput } from './TextInput';
export var isValidEmail = function isValidEmail(email) {
  return /[^\s]+@[^\s]+/.test(email);
};
export function EmailField(props) {
  var id = getId(props);
  return /*#__PURE__*/React.createElement(Field, _extends({}, props, {
    htmlFor: id
  }), /*#__PURE__*/React.createElement(Email, _extends({
    maxWidth: textInputWidth
  }, props, {
    id: id
  })));
}
export function Email(props) {
  var t = useTranslate();
  var emailError = props.value && props.value.trim() && !isValidEmail(props.value) && t('citrix-ui:validation.invalid_email');
  return /*#__PURE__*/React.createElement(TextInput, _extends({}, props, {
    maxLength: 254,
    type: "email",
    errorMessage: emailError || props.errorMessage,
    autoComplete: "email"
  }));
}